module.exports = __webpack_public_path__ + "img/img28.cd3e8829.png";